/* eslint camelcase: 0 */
import actions from '@/features/matchFields/store/matchFields.store.actions'
import mutations from '@/features/matchFields/store/matchFields.store.mutations'
import getters from '@/features/matchFields/store/matchFields.store.getters'

import { ISelectedProjects } from '@/features/projectList/store'

export interface IReservationType {
  id: number,
  value: string,
  label: string
  isRequired: boolean,
  extra_type: string,
  disable?: boolean
}

export interface IParseData {
  parseData: any
}

export interface IMatchFieldsOption {
  item: IMatcherItem,
  value: string
}

export interface IMatcherItem {
  column: string
  sampleValue: string
  assignedField: any
}
export interface IMatchFieldsSendOption {
  jobId: string
  selectedProjects: ISelectedProjects[]
  matcher: any
  matcherForDisplay: any
  allowSend: boolean
  dateTimeFormat: string
}

export interface IIssue {
  type: string,
  message: string
}

export interface IMatchFieldsStore {
  issues: IIssue[]
  types: IReservationType[]
  matcher: any
  matcherForDisplay: any[]
  dateTimeFormat: string,
  isValid: boolean,
  selectedTZ?: string
}

export interface ITransformPayload {
  dateTimeFormat: string,
  job: string,
  selectedTz: string | number,
  matcher: any,
  project: ISelectedProjects
}

export const state: IMatchFieldsStore = {
  isValid: false,
  issues: [],
  types: [],
  matcher: {},
  matcherForDisplay: [],
  dateTimeFormat: 'DD-MM-YYYYTHH:mm:ss',
  selectedTZ: ''
}

export default {
  state,
  actions,
  mutations,
  getters
}
